import { Container } from "pixi.js";
import { AbstractDisplayComponent } from "../core/displays/AbstractDisplayComponent";
import { Logo } from "./Logo";

export class LogoComponent extends AbstractDisplayComponent {
    private container: Container;

    public override init() {
        let containerConfig = {
            labelName: "logo_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {//695, 1470
                posX: 195,
                posY: 1100,
                scale: 0.75,
            },
            portrait: {
                posX: 1024,
                posY: -124,
                scale: 0.7,
            }
        };

        this.container = new Logo(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }
}
